import { format } from 'date-fns'
import { DATE_FORMAT_YYYY_MM_DD } from '../constants'
import { isGuestDefined } from '../helpers'
import { GuestFormData, IChild, IGuest, IPet, LoyaltyProgramData, ServiceFormData } from '../store/data'

type LoyaltyProgramFields = Pick<IGuest, 'loyalty_program_id' | 'loyalty_program_code'>

const getLoyaltyProgramData = (
  loyaltyProgram: LoyaltyProgramData | undefined
): LoyaltyProgramFields | Record<string, never> => {
  if (!loyaltyProgram?.id) {
    return {}
  }

  const parsedId = Number(loyaltyProgram.id)
  if (Number.isNaN(parsedId)) {
    return {}
  }

  return {
    loyalty_program_code: loyaltyProgram.code || '',
    loyalty_program_id: parsedId,
  }
}

export const prepareGuestDataForBookingRequest = (
  guestsData: GuestFormData[],
  servicesFormData: ServiceFormData
) => {
  return guestsData.map((guest, index) => {
    // A guest is optional for a demand, but in this case, we must provide all mandatory data as placeholders.
    const guestDefined = isGuestDefined(guest)

    return {
      ...(!guestDefined
        ? {
            birth_date: format(
              new Date(Math.floor(new Date().getTime() / 1000)),
              DATE_FORMAT_YYYY_MM_DD
            ),
            first_name: 'Guest',
            gender: 'male',
            last_name: `${index + 1}`,
          }
        : {
            birth_date: format(new Date(guest.birth_date!), DATE_FORMAT_YYYY_MM_DD),
            first_name: guest.first_name,
            gender: guest.gender,
            last_name: guest.last_name,
          }),
      ...getLoyaltyProgramData(servicesFormData.loyaltyPrograms?.[index]),
    }
  })
}

export const createCustomerNote = (note: string | null, children: IChild[], pets: IPet[]) => {
  const parts: string[] = []

  if (note?.trim()) {
    parts.push(note.trim())
  }

  if (children.length > 0) {
    const ages = children
      .map((child) => child.age)
      .filter((age): age is number => age !== null) // odstranění null hodnot a type guard
      .sort((a, b) => a - b)
      .join(', ')
    if (ages) {
      parts.push(`Kids ages: ${ages}`)
    }
  }

  if (pets.length > 0) {
    const species = pets
      .map((pet) => pet.species)
      .filter((species): species is string => species !== null) // odstranění null hodnot a type guard
      .sort()
      .join(', ')
    if (species) {
      parts.push(`Pets: ${species}`)
    }
  }

  return parts.length > 0 ? parts.join(' | ') : null
}
